import { React, useState } from "react";
import Person3Icon from '@mui/icons-material/Person3';
import ForumIcon from '@mui/icons-material/Forum';
import BannerBreadcrumb from "../Components/BannerBreadcrumb";
const BlogDescription = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        type: "Blog"
    });
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);
    const [fieldErrors, setFieldErrors] = useState({});

    const validate = () => {
        const errors = {};
        // Name: only letters and spaces
        if (!/^[a-zA-Z\s]*$/.test(formData.name)) {
            errors.name = "Name should contain only letters and spaces.";
        }
        // Phone: must be 10 digits, numeric only
        if (!/^\d{10}$/.test(formData.phone)) {
            errors.phone = "Phone number must be exactly 10 digits.";
        }
        // Email: basic email regex
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            errors.email = "Please enter a valid email address.";
        }
        return errors;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        // For phone, allow only digits
        if (name === "phone") {
            if (!/^\d*$/.test(value)) return;
        }
        // For name, allow only letters and spaces
        if (name === "name") {
            if (!/^[a-zA-Z\s]*$/.test(value)) return;
        }
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
        setFieldErrors((prev) => ({
            ...prev,
            [name]: undefined
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccess(false);
        setError(null);

        const errors = validate();
        setFieldErrors(errors);
        if (Object.keys(errors).length > 0) {
            setLoading(false);
            return;
        }

        setLoading(true);

        try {
            const formBody = new URLSearchParams(formData).toString();
            await fetch("https://script.google.com/macros/s/AKfycbytFPsSA7Ob7jAQVmRXGHReCfkcWZmnCvpOLdSL7Zw3kEIvSn5YoQELdQBZOLJccA0/exec", {
                method: "POST",
                body: formBody,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            });
            setSuccess(true);
            setFormData({
                name: "",
                email: "",
                phone: "",
                type: "Blog"
            });
        } catch (err) {
            console.error("Error submitting form:", err);
            setError("Failed to submit. Please try again.");
        }

        setLoading(false);
    };
    return (
        <>
            <BannerBreadcrumb head={"Blog Description"} pagename={"Blog Description"} />
            <section className="blog-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8 loan-eligibility ">
                            <h5 className="about-head">Academic Pursuits and Beyond: A Student's Experience at Michigan State University</h5>
                            <img src="/images/blog.jpg" alt="Blog Image" className="img-fluid mb-4" />
                            <h5 className="about-head">Morning Routines and the Pursuit of Knowledge</h5>
                            <p className="loan-elegibility-des">
                            As the first light of dawn softly filters through my window each morning, I am stirred by a deep sense of determination. Promptly at 6 AM, I set off on my day, embraced by the assurance of fresh opportunities. Following a brisk revitalization and a wholesome breakfast, I venture out, ready to tackle the challenges that await me at Michigan State University (MSU).
                            </p>
                            <p className="loan-elegibility-des">
                            At 8 AM, my classes begin, marking the start of a day filled with immersive learning. These vital lectures, along with interactive labs, are the foundation of my academic week and greatly enrich my knowledge of construction management. Engaging classroom discussions and hands-on lab sessions go beyond theory, preparing me to solve real-world problems in my field.
                            </p>

                            <h5 className="about-head">Exploring MSU Campus: A Journey through Public Transit and Environmental Awareness</h5>
                            <p className="loan-elegibility-des">
                            MSU's campus is vast and demands efficient transportation. The university meets this need seamlessly through the CATA bus service, which plays a crucial role in student life. I'm fortunate that my apartment management provides complimentary CATA bus passes, and my daily commute begins with a short two-minute walk.
                            </p>
                            <p className="loan-elegibility-des">
                            With the help of the Transit app and a reliable pre-departure checklist, commuting is smooth and hassle-free. Prioritizing public transport not only builds campus connection but also aligns with MSU’s commitment to sustainability. In such an academic setting, owning a car becomes unnecessary and impractical.
                            </p>

                            <h5 className="about-head">Achieving a Balance Between Academic Challenges and Personal Development Outside the Classroom</h5>
                            <p className="loan-elegibility-des">
                            After noon, I transition from academic work to personal growth. Once home, I prepare a nutritious lunch and dive into assignments with focus and enthusiasm. These tasks challenge me mentally, pushing me to continuously learn and grow.
                            </p>
                            <p className="loan-elegibility-des">
                            Involvement in university clubs enhances my experience by fostering meaningful interactions with peers and faculty. For focused study, I often retreat to the serene campus library, where the soft rustle of turning pages symbolizes my ongoing quest for knowledge.
                            </p>

                            <h5 className="about-head">Developing Endurance and Mental Strength during Evening Exercise</h5>
                            <p className="loan-elegibility-des">
                            Evenings are dedicated to health and self-improvement. My two-hour gym sessions not only build physical endurance but also serve as powerful stress relievers. Physical activity offers mental clarity and boosts my ability to remain composed under pressure.
                            </p>
                            <p className="loan-elegibility-des">
                            Dinner becomes a time for reflection and planning. It’s a moment to assess my progress, set goals, and prepare for the day ahead—both academically and personally.
                            </p>

                            <h5 className="about-head">Conquering Academic Challenges: Devotion and Constant Growth</h5>
                            <p className="loan-elegibility-des">
                            Despite the demanding nature of my coursework, I find genuine satisfaction in my steady progress. By dedicating ample time to my academic responsibilities, I stay ahead of deadlines and fully prepared for every challenge. This consistent effort ensures I’m always building my knowledge and competence.
                            </p>

                            <h5 className="about-head">Balancing Academic Goals with Financial Responsibilities is a Skill Worth Mastering</h5>
                            <p className="loan-elegibility-des">
                            My on-campus job provides more than financial benefits—it allows me to apply my classroom learning in real-world contexts. It’s been a valuable opportunity to work alongside experts in my field and gain hands-on experience that will support my career.
                            </p>
                            <p className="loan-elegibility-des">
                            The flexibility of my work schedule enables me to manage academic demands without compromise. This balance between work, school, and life has become central to my growth and personal development.
                            </p>

                            <h5 className="about-head">Conclusion</h5>
                            <p className="loan-elegibility-des">
                            I enthusiastically integrate the values of learning, determination, and resilience into my daily routine. Every moment at MSU contributes meaningfully to both my personal and professional evolution.
                            </p>
                            <p className="loan-elegibility-des">
                            My educational journey is a reflection of my commitment to overcoming challenges, building lasting connections, and becoming a confident, skilled professional ready to make an impact in my field.
                            </p>

                        </div>
                        <div className="col-md-4">
                            <div className="blog-right">
                                <form className="loan-check-form" style={{ padding: "50px" }} onSubmit={handleSubmit}>
                                    <h4 className="" style={{ fontSize: "20px" }}>Need Help in education loan?</h4>
                                    {success && <div className="alert alert-success mt-2">Submitted successfully!</div>}
                                    {error && <div className="alert alert-danger mt-2">{error}</div>}
                                    <div className="row">
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Name <span>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="E.g. Priya Senger"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.name && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.name}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Email <span>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="E.g. priya@doe.com"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.email && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.email}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Phone<span>*</span></label>
                                            <input
                                                type="tel"
                                                className="form-control finance-input"
                                                placeholder="E.g. 8888880000"
                                                name="phone"
                                                value={formData.phone}
                                                onChange={handleChange}
                                                required
                                                maxLength={10}
                                            />
                                            {fieldErrors.phone && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.phone}</div>
                                            )}
                                        </div>
                                        <div className="col-12">
                                            <button type="submit" className="loan-btn w-100 mt-3">Register Now</button>
                                        </div>
                                    </div>
                                </form>

                                <section className="landing-partners mt-5" >
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <h5 className="about-head mb-5 text-center">Our Best Landing Partners</h5>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/icici-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/auxilo-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/avanse-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/axis-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/bob-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/hdfc-credila-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/union-bank-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/idfc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/increc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/mpower-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/prodigy-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/sbi-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default BlogDescription;